"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Version = void 0;

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var PropTypes = _interopRequireWildcard(require("prop-types"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Version =
/*#__PURE__*/
function (_Component) {
  _inherits(Version, _Component);

  function Version() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Version);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Version)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "showInfo", function (e) {
      e.preventDefault();
      var _this$props$version = _this.props.version,
          version = _this$props$version.version,
          time = _this$props$version.time,
          id = _this$props$version.id,
          branch = _this$props$version.branch; // TODO: translate modal title

      _antd.Modal.info({
        width: 650,
        title: 'Application version info',
        content: _react["default"].createElement("div", null, _react["default"].createElement(_antd.Row, null, _react["default"].createElement(_antd.Col, {
          sm: 12
        }, "Version"), _react["default"].createElement(_antd.Col, {
          sm: 12
        }, version)), _react["default"].createElement(_antd.Row, null, _react["default"].createElement(_antd.Col, {
          sm: 12
        }, "Build date"), _react["default"].createElement(_antd.Col, {
          sm: 12
        }, time)), _react["default"].createElement(_antd.Row, null, _react["default"].createElement(_antd.Col, {
          sm: 12
        }, "Branch"), _react["default"].createElement(_antd.Col, {
          sm: 12
        }, branch)), _react["default"].createElement(_antd.Row, null, _react["default"].createElement(_antd.Col, {
          sm: 12
        }, "Commit id"), _react["default"].createElement(_antd.Col, {
          sm: 12
        }, id))),
        onOk: function onOk() {}
      });
    });

    return _this;
  }

  _createClass(Version, [{
    key: "render",
    value: function render() {
      var version = this.props.version.version;
      var withDetails = this.props.withDetails;
      return _react["default"].createElement(_react["default"].Fragment, null, version && _react["default"].createElement("span", null, " v.", version, withDetails && _react["default"].createElement("button", {
        style: {
          border: 'none',
          background: 'none',
          cursor: 'pointer'
        },
        onClick: this.showInfo
      }, _react["default"].createElement(_antd.Icon, {
        type: "question-circle"
      }))));
    }
  }]);

  return Version;
}(_react.Component);

exports.Version = Version;

_defineProperty(Version, "propsTypes", {
  withDetails: PropTypes.bool
});

_defineProperty(Version, "defaultProps", {
  withDetails: true
});